// extracted by mini-css-extract-plugin
module.exports =  {"leftBox":"AddGasModal-module_leftBox_e8206","title":"AddGasModal-module_title_f630a","textArea":"AddGasModal-module_textArea_c68c8"};